(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["probimel-woman-contact"] && !Shopify.designMode) return;
  try {
    (() => {
  const synchronizers = new WeakMap();
  const initializeProductEnquiries = () => {
    document.querySelectorAll('form[data-probimel-product-enquiry]').forEach(form => {
      if (form.dataset.probimelEnquiryReady) {
        const sync = synchronizers.get(form);
        if (sync) sync(false);
        return;
      }
      form.dataset.probimelEnquiryReady = 'true';
      const source = form.querySelector('[data-probimel-product-variants]');
      let variants = [];
      try { variants = JSON.parse(source.textContent); } catch (error) { variants = []; }
      const byId = new Map(variants.map(variant => [String(variant.id), variant]));
      const variantId = form.querySelector('[data-probimel-variant-id]');
      const variantTitle = form.querySelector('[data-probimel-variant-title]');
      const selectedFormat = form.querySelector('[data-probimel-selected-format]');
      const productUrl = form.querySelector('[data-probimel-product-url]');
      const formatLabel = form.querySelector('[data-probimel-format-label]');
      const selectionError = form.querySelector('[data-probimel-selection-error]');
      const mainFormId = form.dataset.mainProductFormId;
      const stickyFormId = mainFormId.replace(/^product-form-/, 'product-form-sticky-');
      let lastSelectionFormId = null;
      let lastSelectionFromWidget = false;
      const resolveFormVariant = (purchaseForm, preferVisibleSelection = false) => {
        if (!purchaseForm || purchaseForm.tagName !== 'FORM') return null;
        const ids = Array.from(new Set(new FormData(purchaseForm).getAll('id').map(String).filter(Boolean)));
        if (ids.length !== 1) return null;
        const variant = byId.get(ids[0]);
        if (!variant) return null;
        const widget = purchaseForm.querySelector('product-variant-swatch, product-variant-dropdown, product-variant-selects-stick');
        if (widget) {
          let options = [];
          if (widget.localName !== 'product-variant-swatch') {
            options = Array.from(widget.querySelectorAll('select'), select => select.value);
          } else {
            options = Array.from(widget.querySelectorAll('fieldset'), fieldset => {
              const selected = fieldset.querySelector('input[type="radio"]:checked');
              return selected ? selected.value : null;
            });
          }
          const optionVariants = variants.filter(candidate => options.length === candidate.options.length && options.every((option, index) => option === candidate.options[index]));
          if (optionVariants.length !== 1) return null;
          if (preferVisibleSelection) return optionVariants[0];
          if (String(optionVariants[0].id) !== String(variant.id)) return null;
        }
        return variant;
      };
      const resolveVariant = () => {
        const mainForm = document.getElementById(mainFormId);
        const stickyForm = document.getElementById(stickyFormId);
        if (!mainForm) return null;
        if (lastSelectionFormId === stickyFormId) return resolveFormVariant(stickyForm, lastSelectionFromWidget);
        if (lastSelectionFormId === mainFormId) return resolveFormVariant(mainForm, lastSelectionFromWidget);
        const mainVariant = resolveFormVariant(mainForm);
        const stickyVariant = resolveFormVariant(stickyForm);
        if (stickyForm && (!mainVariant || !stickyVariant || String(mainVariant.id) !== String(stickyVariant.id))) return null;
        return mainVariant;
      };
      const synchronize = showError => {
        const variant = resolveVariant();
        if (!variant) {
          variantId.value = '';
          variantTitle.value = '';
          selectedFormat.value = '';
          productUrl.value = form.dataset.productUrl;
          if (formatLabel) formatLabel.textContent = form.dataset.selectionError;
          if (selectionError) selectionError.hidden = !showError;
          return false;
        }
        const format = variant.title === 'Default Title' ? form.dataset.productTitle : variant.title;
        variantId.value = String(variant.id);
        variantTitle.value = format;
        selectedFormat.value = format;
        const url = new URL(form.dataset.productUrl, window.location.origin);
        url.searchParams.set('variant', String(variant.id));
        productUrl.value = url.href;
        if (formatLabel) formatLabel.textContent = format;
        if (selectionError) selectionError.hidden = true;
        return true;
      };
      synchronizers.set(form, synchronize);
      synchronize(false);
      [mainFormId, stickyFormId].forEach(purchaseFormId => {
        const purchaseForm = document.getElementById(purchaseFormId);
        if (!purchaseForm) return;
        purchaseForm.addEventListener('change', event => {
          if (!form.isConnected || !(event.target instanceof Element)) return;
          const widget = event.target.closest('product-variant-swatch, product-variant-dropdown, product-variant-selects-stick');
          const variantControlChanged = event.target.name === 'id' && event.target.form === purchaseForm;
          if ((widget && purchaseForm.contains(widget)) || variantControlChanged) {
            lastSelectionFormId = purchaseFormId;
            lastSelectionFromWidget = Boolean(widget && purchaseForm.contains(widget));
            synchronize(false);
          }
        });
        purchaseForm.addEventListener('click', event => {
          if (!form.isConnected || !(event.target instanceof Element)) return;
          const label = event.target.closest('label');
          const control = event.target.closest('input[type="radio"]') || (label && label.control);
          if (!control || control.type !== 'radio' || !control.checked || !purchaseForm.contains(control)) return;
          const widget = control.closest('product-variant-swatch');
          if (!widget || !purchaseForm.contains(widget)) return;
          lastSelectionFormId = purchaseFormId;
          lastSelectionFromWidget = true;
          synchronize(false);
        });
      });
      const serverResult = form.querySelector('[data-probimel-contact-result="success"], [data-probimel-contact-result="error"]');
      if (serverResult) {
        let resultOpened = false;
        const showServerResult = () => {
          if (!form.isConnected || resultOpened) return;
          const modal = form.closest('#Shopask');
          const opener = document.querySelector('.probimel-product-help button[data-target="#Shopask"]');
          if (modal && !modal.classList.contains('show')) {
            try {
              if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.modal === 'function') {
                const dialog = window.jQuery(modal);
                dialog.off('shown.bs.modal.probimelContactResult').one('shown.bs.modal.probimelContactResult', () => {
                  if (!form.isConnected || !modal.classList.contains('show')) return;
                  resultOpened = true;
                  const inlineResult = document.querySelector('[data-probimel-inline-contact-result]');
                  if (inlineResult) inlineResult.remove();
                });
                dialog.modal('show');
              } else if (opener) opener.click();
            } catch (error) {}
          }
          const existing = document.querySelector('[data-probimel-inline-contact-result]');
          if (modal && modal.classList.contains('show')) {
            resultOpened = true;
            if (existing) existing.remove();
            return;
          }
          if (existing) return;
          const notice = serverResult.cloneNode(true);
          notice.removeAttribute('id');
          notice.removeAttribute('data-probimel-contact-result');
          notice.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          notice.className = 'probimel-product-confirmation';
          if (serverResult.getAttribute('data-probimel-contact-result') === 'error') notice.classList.add('probimel-product-confirmation--error');
          notice.setAttribute('data-probimel-inline-contact-result', 'true');
          const help = opener && opener.closest('.probimel-product-help');
          if (help) help.insertAdjacentElement('afterend', notice);
          else (document.getElementById('MainContent') || document.body).prepend(notice);
        };
        showServerResult();
        if (document.readyState !== 'complete') window.addEventListener('load', showServerResult, { once: true });
      }
      const wrapper = form.querySelector('[data-validation-message]');
      if (!wrapper) return;
      const fields = form.querySelectorAll('[name="contact[name]"], [name="contact[body]"]');
      const validateText = () => fields.forEach(field => field.setCustomValidity(field.value.trim() ? '' : wrapper.dataset.validationMessage));
      fields.forEach(field => field.addEventListener('input', validateText));
      form.addEventListener('submit', event => {
        validateText();
        const selected = synchronize(true);
        if (!selected || !form.reportValidity()) {
          event.preventDefault();
          if (!selected && selectionError) {
            selectionError.setAttribute('tabindex', '-1');
            selectionError.focus();
          }
        }
      });
    });
  };
  document.addEventListener('click', event => {
    const opener = event.target instanceof Element ? event.target.closest('.probimel-product-help button[data-target="#Shopask"]') : null;
    if (!opener) return;
    const form = document.querySelector('form[data-probimel-product-enquiry]');
    const synchronize = form && synchronizers.get(form);
    if (synchronize) synchronize(true);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeProductEnquiries, { once: true });
  else initializeProductEnquiries();
  document.addEventListener('shopify:section:load', initializeProductEnquiries);
  window.addEventListener('pageshow', initializeProductEnquiries);
})();
  } catch(e) { console.error(e); }
})();

})();
